import styled from '@emotion/styled';
import tw from 'twin.macro';

export const StyledToggle = styled.button`
  ${tw`relative`}
`;

export const StyledToggleLabel = styled.h3`
  ${tw`font-semi-bold font-poppins`}
  ${tw`text-left text-mobile-heading-xxs md:text-heading-xxs text-primary-p1`}
  ${tw`pr-5`}
`;

export const StyledToggleCircle = styled.span`
  ${tw`w-[24px] h-[24px]`}
  ${tw`rounded-full`}
  ${tw`text-neutrals-n1 text-heading-xs`}
  ${tw`bg-secondary-s1`}
  ${tw`leading-5`}
  ${tw`absolute`}
  ${tw`right-0 top-0`}
  ${tw`transition-transform`}
`;

export const StyledContentContainer = styled.div`
  ${tw`font-inter`}
  ${tw`text-body-m text-primary-p1`}
  ${tw`mt-3`}
`;

export const StyledRichText = styled.div`
  ${tw`font-inter`};
  p {
    ${tw`text-body-m text-primary-p1`}
    & + ul,
    & + ol {
      ${tw`mt-2`}
    }
  }
  ol,
  ul {
    ${tw`mb-2 pl-0`}
    ${tw`list-none`}
    li {
      ${tw`relative`}
      ${tw`mb-2`}
      ${tw`text-body-l text-primary-p1`}
    }
  }
  ul {
    li {
      ${tw`pl-2`}
      &:before {
        ${tw`absolute`}
        ${tw`left-0 top-[12px]`}
        ${tw`w-[4px] h-[4px]`}
        ${tw`opacity-100`}
        ${tw`content-['']`}
        ${tw`bg-primary-p2`}
      }
    }
  }
  ol {
    &:first-of-type {
      counter-reset: customlistcounter;
    }
    li {
      counter-increment: customlistcounter;
      &:before {
        ${tw`text-primary-p2`}
        content: counter(customlistcounter) ' ';
      }
    }
  }
  a {
    ${tw`text-primary-p1`}
    ${tw`underline hover:no-underline`}
  }
  code {
    ${tw`text-tag-m`}
  }
`;

export const StyledAccordionItem = styled.div<{ isActive: boolean; hasPricingTheme?: boolean }>`
  ${tw`flex flex-col`}
  ${tw`py-3`}
  ${tw`border-b border-solid border-neutrals-n5`}

  ${StyledToggleCircle} {
    ${({ isActive }) => (isActive ? tw`rotate-90` : tw`rotate-0`)}
  }

  ${StyledRichText} {
    p {
      ${tw`text-body-m`}
    }
  }

  ${StyledContentContainer} {
    ${({ isActive }) => (isActive ? tw`block` : tw`hidden`)}
  }
`;
